import { useEffect, useState } from 'react';

export const useLocalValue = value => {
    const [localValue, setLocalValue] = useState(value);
    useEffect(() => {
        setLocalValue(value);
    }, [value]);
    return [localValue, setLocalValue];
};
